// Client-side QR generation used when offline, mirroring the backend
// QRUtils.generateCustomQRBase64 (which encodes the plain userId into a 300x300
// PNG). Returns RAW base64 (no data: prefix) to match the backend's
// qrCodeBase64 field, so existing badge renderers work unchanged.
import QRCode from 'qrcode';

const cache = new Map();

export async function generateQrBase64(text) {
  if (!text) return null;
  const key = String(text);
  if (cache.has(key)) return cache.get(key);
  try {
    const dataUrl = await QRCode.toDataURL(key, { width: 300, margin: 1 });
    const base64 = dataUrl.replace(/^data:image\/png;base64,/, '');
    cache.set(key, base64);
    return base64;
  } catch (_) {
    return null;
  }
}
